import { getDefaultExerciseVersion } from '../../config';
import { AudioSoundEvent, Exercise, Phase, ScheduleEntryColourCode, SessionSequence } from '../../entities';
import { ISessionSequenceStrategy } from './isessionsequencestrategy';

export class Warmdown implements ISessionSequenceStrategy {
    public getSessionSequence(
        exercise: Exercise,
        alernativeExercise: Exercise,
        secondAternativeExercise: Exercise,
        thirdAlternateExercise: Exercise,
        zone: number,
        quarter: number,
      ): SessionSequence[] {
        return [{
            durationInMilliseconds: 10,
            sequence: [{
                durationInMilliseconds: 10,
                videoFile: SessionSequence.preWarmdownVideoName(),
                exerciseVersion: getDefaultExerciseVersion(),
                displayName: exercise.name,
                displayBurnOrBuildIcon: false,
                progressColourCode: ScheduleEntryColourCode.Rest,
                progressText: 'Starts in {seconds}',
                showProcessedMetrics: true,
                showCalculatedMetrics: true,
                audioSoundEvent: undefined,
                tips: Exercise.getFormattedTips(exercise),
                phase: Phase.Rest,
                zone,
            }],
        }, {
            durationInMilliseconds: 10,
            sequence: [{
                durationInMilliseconds: 10,
                videoFile: exercise.uniqueReferenceNumber,
                exerciseVersion: exercise._rev,
                displayName: exercise.name,
                displayBurnOrBuildIcon: true,
                progressColourCode: ScheduleEntryColourCode.Play,
                progressText: 'Cool down starting',
                showProcessedMetrics: true,
                showCalculatedMetrics: true,
                audioSoundEvent: undefined,
                tips: Exercise.getFormattedTips(exercise),
                phase: Phase.Train,
                zone,
            }],
        }, {
            durationInMilliseconds: 90,
            sequence: [{
                durationInMilliseconds: 90,
                videoFile: exercise.uniqueReferenceNumber,
                exerciseVersion: exercise._rev,
                displayName: exercise.name,
                displayBurnOrBuildIcon: true,
                progressColourCode: ScheduleEntryColourCode.Play,
                progressText: 'Cool down for {seconds}',
                showProcessedMetrics: true,
                showCalculatedMetrics: true,
                // the beep is weird here, but we want this beep time to match exercise beep timing:
                audioSoundEvent: AudioSoundEvent.startOfWorkout,
                tips: Exercise.getFormattedTips(exercise),
                phase: Phase.Train,
                zone,
            }],
        }, {
            durationInMilliseconds: 6,
            sequence: [{
                durationInMilliseconds: 6,
                videoFile: SessionSequence.postWarmdownVideoName(),
                exerciseVersion: getDefaultExerciseVersion(),
                displayName: exercise.name,
                displayBurnOrBuildIcon: false,
                progressColourCode: ScheduleEntryColourCode.Rest,
                progressText: 'Well done!',
                showProcessedMetrics: true,
                showCalculatedMetrics: true,
                tips: Exercise.getFormattedTips(exercise),
                phase: Phase.Rest,
                zone,
            }],
        }, {
            durationInMilliseconds: 4,
            sequence: [{
                durationInMilliseconds: 4,
                videoFile: SessionSequence.postWarmdownVideoName(),
                exerciseVersion: getDefaultExerciseVersion(),
                displayName: exercise.name,
                displayBurnOrBuildIcon: false,
                progressColourCode: ScheduleEntryColourCode.Rest,
                progressText: 'Session ended',
                showProcessedMetrics: true,
                showCalculatedMetrics: true,
                audioSoundEvent: AudioSoundEvent.endOfWorkoutSession,
                tips: Exercise.getFormattedTips(exercise),
                phase: Phase.Rest,
                zone,
            }],
        }];
    }
}
